import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  de: {
    // Navigation
    nav_home: "Start",
    nav_services: "Services",
    nav_products: "Produkte",
    nav_booking: "Termin buchen",
    nav_membership: "Mitgliedschaft",
    nav_login: "Anmelden",
    nav_register: "Registrieren",
    nav_dashboard: "Dashboard",
    nav_admin: "Admin",
    nav_logout: "Abmelden",
    
    // Hero
    hero_title: "Perfektion für",
    hero_title_highlight: "Ihr Fahrzeug",
    hero_subtitle: "Professionelle Fahrzeugaufbereitung mit höchsten Ansprüchen. Erleben Sie den Unterschied – jetzt Termin vereinbaren.",
    hero_cta: "Termin buchen",
    hero_services: "Services entdecken",
    
    // Services
    services_title: "Unsere Services",
    services_subtitle: "Professionelle Fahrzeugaufbereitung für jeden Anspruch.",
    services_book: "Buchen",
    services_from: "ab",
    services_duration: "Dauer",
    services_points: "Treuepunkte",
    
    // Products
    products_title: "Unsere Produkte",
    products_subtitle: "Hochwertige Pflegeprodukte für Ihr Fahrzeug.",
    products_in_stock: "Auf Lager",
    products_out_of_stock: "Ausverkauft",
    products_category_all: "Alle",
    products_category_cleaning: "Reinigung",
    products_category_protection: "Schutz",
    products_category_accessories: "Zubehör",
    
    // Booking
    booking_title: "Termin buchen",
    booking_select_service: "Service wählen",
    booking_select_date: "Datum wählen",
    booking_select_time: "Uhrzeit wählen",
    booking_vehicle_type: "Fahrzeugtyp",
    booking_notes: "Anmerkungen (optional)",
    booking_recurring: "Wiederkehrende Buchung",
    booking_recurring_interval: "Intervall",
    booking_weekly: "Wöchentlich",
    booking_biweekly: "Alle 2 Wochen",
    booking_monthly: "Monatlich",
    booking_summary: "Zusammenfassung",
    booking_price: "Preis",
    booking_confirm: "Termin bestätigen",
    booking_login_required: "Bitte melden Sie sich an, um einen Termin zu buchen.",
    
    // Membership
    membership_title: "Werden Sie Mitglied",
    membership_subtitle: "Profitieren Sie von exklusiven Vorteilen und sparen Sie bei jeder Buchung.",
    membership_free: "Basis-Mitglied",
    membership_premium: "Premium-Mitglied",
    membership_current: "Aktueller Plan",
    membership_upgrade: "Jetzt upgraden",
    membership_per_month: "/ Monat",
    
    // Dashboard
    dashboard_welcome: "Willkommen",
    dashboard_upcoming: "Anstehende Termine",
    dashboard_past: "Vergangene Termine",
    dashboard_offers: "Angebote",
    dashboard_loyalty: "Treuepunkte",
    dashboard_no_bookings: "Keine anstehenden Termine.",
    dashboard_book_now: "Jetzt buchen",
    dashboard_new_booking: "Neuer Termin",
    dashboard_cancel: "Stornieren",
    
    // Loyalty
    loyalty_title: "Treueprogramm",
    loyalty_points: "Punkte",
    loyalty_rewards: "Prämien",
    loyalty_redeem: "Einlösen",
    loyalty_history: "Verlauf",
    loyalty_not_enough: "Nicht genügend Punkte",
    
    // Reviews
    reviews_title: "Bewertungen",
    reviews_write: "Bewertung schreiben",
    reviews_rating: "Bewertung",
    reviews_comment: "Kommentar",
    reviews_submit: "Absenden",
    reviews_average: "Durchschnitt",
    
    // Auth
    auth_login: "Anmelden",
    auth_register: "Registrieren",
    auth_email: "E-Mail-Adresse",
    auth_password: "Passwort",
    auth_confirm_password: "Passwort bestätigen",
    auth_name: "Name",
    auth_phone: "Telefon (optional)",
    auth_forgot: "Passwort vergessen?",
    auth_no_account: "Noch kein Konto?",
    auth_has_account: "Bereits ein Konto?",
    
    // Admin
    admin_title: "Admin Dashboard",
    admin_stats: "Statistiken",
    admin_users: "Benutzer",
    admin_bookings: "Buchungen",
    admin_total_users: "Benutzer gesamt",
    admin_premium_users: "Premium-Mitglieder",
    admin_total_bookings: "Buchungen gesamt",
    admin_revenue: "Umsatz",
    admin_mark_complete: "Als erledigt markieren",
    admin_notifications: "Benachrichtigungen",
    
    // Common
    common_loading: "Wird geladen...",
    common_error: "Fehler aufgetreten",
    common_success: "Erfolgreich",
    common_cancel: "Abbrechen",
    common_save: "Speichern",
    common_delete: "Löschen",
    common_edit: "Bearbeiten",
    common_close: "Schließen",
    common_search: "Suchen",
    common_filter: "Filtern",
    common_all: "Alle",
    common_date: "Datum",
    common_time: "Uhrzeit",
    common_status: "Status",
    common_confirmed: "Bestätigt",
    common_completed: "Abgeschlossen",
    common_cancelled: "Storniert",
    
    // Footer
    footer_contact: "Kontakt",
    footer_hours: "Öffnungszeiten",
    footer_rights: "Alle Rechte vorbehalten",
  },
  en: {
    // Navigation
    nav_home: "Home",
    nav_services: "Services",
    nav_products: "Products",
    nav_booking: "Book Appointment",
    nav_membership: "Membership",
    nav_login: "Login",
    nav_register: "Register",
    nav_dashboard: "Dashboard",
    nav_admin: "Admin",
    nav_logout: "Logout",
    
    // Hero
    hero_title: "Perfection for",
    hero_title_highlight: "Your Vehicle",
    hero_subtitle: "Professional car detailing with the highest standards. Experience the difference – book your appointment now.",
    hero_cta: "Book Appointment",
    hero_services: "Explore Services",
    
    // Services
    services_title: "Our Services",
    services_subtitle: "Professional car detailing for every need.",
    services_book: "Book",
    services_from: "from",
    services_duration: "Duration",
    services_points: "Loyalty Points",
    
    // Products
    products_title: "Our Products",
    products_subtitle: "Premium care products for your vehicle.",
    products_in_stock: "In Stock",
    products_out_of_stock: "Out of Stock",
    products_category_all: "All",
    products_category_cleaning: "Cleaning",
    products_category_protection: "Protection",
    products_category_accessories: "Accessories",
    
    // Booking
    booking_title: "Book Appointment",
    booking_select_service: "Select Service",
    booking_select_date: "Select Date",
    booking_select_time: "Select Time",
    booking_vehicle_type: "Vehicle Type",
    booking_notes: "Notes (optional)",
    booking_recurring: "Recurring Booking",
    booking_recurring_interval: "Interval",
    booking_weekly: "Weekly",
    booking_biweekly: "Bi-weekly",
    booking_monthly: "Monthly",
    booking_summary: "Summary",
    booking_price: "Price",
    booking_confirm: "Confirm Booking",
    booking_login_required: "Please log in to book an appointment.",
    
    // Membership
    membership_title: "Become a Member",
    membership_subtitle: "Enjoy exclusive benefits and save on every booking.",
    membership_free: "Free Member",
    membership_premium: "Premium Member",
    membership_current: "Current Plan",
    membership_upgrade: "Upgrade Now",
    membership_per_month: "/ month",
    
    // Dashboard
    dashboard_welcome: "Welcome",
    dashboard_upcoming: "Upcoming Appointments",
    dashboard_past: "Past Appointments",
    dashboard_offers: "Offers",
    dashboard_loyalty: "Loyalty Points",
    dashboard_no_bookings: "No upcoming appointments.",
    dashboard_book_now: "Book Now",
    dashboard_new_booking: "New Booking",
    dashboard_cancel: "Cancel",
    
    // Loyalty
    loyalty_title: "Loyalty Program",
    loyalty_points: "Points",
    loyalty_rewards: "Rewards",
    loyalty_redeem: "Redeem",
    loyalty_history: "History",
    loyalty_not_enough: "Not enough points",
    
    // Reviews
    reviews_title: "Reviews",
    reviews_write: "Write Review",
    reviews_rating: "Rating",
    reviews_comment: "Comment",
    reviews_submit: "Submit",
    reviews_average: "Average",
    
    // Auth
    auth_login: "Login",
    auth_register: "Register",
    auth_email: "Email Address",
    auth_password: "Password",
    auth_confirm_password: "Confirm Password",
    auth_name: "Name",
    auth_phone: "Phone (optional)",
    auth_forgot: "Forgot password?",
    auth_no_account: "Don't have an account?",
    auth_has_account: "Already have an account?",
    
    // Admin
    admin_title: "Admin Dashboard",
    admin_stats: "Statistics",
    admin_users: "Users",
    admin_bookings: "Bookings",
    admin_total_users: "Total Users",
    admin_premium_users: "Premium Members",
    admin_total_bookings: "Total Bookings",
    admin_revenue: "Revenue",
    admin_mark_complete: "Mark Complete",
    admin_notifications: "Notifications",
    
    // Common
    common_loading: "Loading...",
    common_error: "Error occurred",
    common_success: "Success",
    common_cancel: "Cancel",
    common_save: "Save",
    common_delete: "Delete",
    common_edit: "Edit",
    common_close: "Close",
    common_search: "Search",
    common_filter: "Filter",
    common_all: "All",
    common_date: "Date",
    common_time: "Time",
    common_status: "Status",
    common_confirmed: "Confirmed",
    common_completed: "Completed",
    common_cancelled: "Cancelled",
    
    // Footer
    footer_contact: "Contact",
    footer_hours: "Opening Hours",
    footer_rights: "All rights reserved",
  }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("language") || "de";
  });

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations.de[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "de" ? "en" : "de"));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
